import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createRoadEvent } from 'features/siteNetwork/siteNetworkSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { ICloseRoadModalProps } from 'types/siteNetwork.interface'
import { RoadEventType } from 'types/siteNetworkEnums.interface'
import { ISelectValue } from 'constants/globalTypes'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { roadEventTypeOptions } from './siteNetworkData'

export const CloseRoadModal = ({
  closeModal,
  siteNodeId,
  segmentId,
  segmentName,
}: ICloseRoadModalProps) => {
  const [reason, setReason] = useState('')
  const [eventType, setEventType] = useState(RoadEventType.Closed)
  const [speedKmh, setSpeedKmh] = useState('')
  const dispatch = useDispatch<AppDispatch>()
  useFocusFirstInput()
  useModalClose(closeModal)

  const handleSave = async () => {
    const payload =
      eventType === RoadEventType.SpeedLimit && speedKmh
        ? { kmh: Number(speedKmh) }
        : undefined
    const resp = await dispatch(
      createRoadEvent({
        siteNodeId,
        body: {
          type: eventType,
          segmentId,
          reason: reason.trim(),
          payload,
        },
      }),
    )
    if (resp.meta.requestStatus === 'fulfilled') {
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
          <TitleText weight='bold'>Road event</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <BodyText grey>{segmentName ?? segmentId}</BodyText>
        <HonestSelectInput
          nomarg
          labelText='Event type'
          options={roadEventTypeOptions}
          defaultValue={eventType}
          onChange={(v: ISelectValue) => setEventType(Number(v.value))}
        />
        {eventType === RoadEventType.SpeedLimit && (
          <Input
            nomarg
            type='number'
            labelText='Speed limit (km/h)'
            value={speedKmh}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSpeedKmh(e.target.value)}
          />
        )}
        <Input
          placeholder='e.g. blasting 12:00–14:00, grader works…'
          labelText='Reason (required)'
          value={reason}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setReason(e.target.value)}
          nomarg
        />
        <Button mt='16' disabled={!reason.trim()} orange onClick={handleSave}>
          Create event
        </Button>
      </Flex>
    </Modal>
  )
}
